import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import { Box } from "@mui/material";
import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formTableRow } from "../../types/index"
import { useStyles } from "./styles";

type Props = {
  rows: formTableRow[] | undefined;
  loading?: boolean;
};

 const FormsTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();


  const columns = useMemo(
    () => [
      {
        id: "sortorder",
        label: t("BOOKS.TABLE.SORT"),
        minWidth: 100,
        align: "right",
      },
      {
        id: "formGroup",
        label: t("BOOKS.TABLE.GROUP"),
        minWidth: 90,
        align: "right",
      },
      {
        id: "formDesc",
        label: t("BOOKS.TABLE.FORM_NAME"),
        minWidth: 140,
        align: "right",
        format: (row: formTableRow) => t(row.formDesc)
      },
      {
        id: "fileName",
        label: t("BOOKS.TABLE.FILE_NAME"),
        minWidth: 160,
        align: "right",
        format: (row: formTableRow) => t(row.fileName)
      }
    ],
    [styles, t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows || []}
        columns={columns}
        loading={loading}
        serialEnabled={false}
        isPointerCursor
      />
    </div>
  );
};

export default FormsTable;
